import type { init } from "@sentry/nextjs";

import { CREDENTIAL_PARAMS, STRIPE_RETURN_PARAMS } from "./redact-url";

type DataCollection = NonNullable<
  NonNullable<Parameters<typeof init>[0]>["dataCollection"]
>;

// Sentry's own "keep the v10 behaviour" list: header and query names carrying the
// visitor's IP, geo or identity. In 11 a bare `true` means "collect, unfiltered".
const PII_KEY_DENY = ["forwarded", "-ip", "remote-", "via", "-user"];

// Sentry 11 collects user info, cookies, bodies, DB queries and GenAI text by default;
// this keeps the SDK 10 `sendDefaultPii: false` posture. The query names the URL
// scrubber redacts on events (STRIPE_RETURN_PARAMS carries `email` and `token_hash` too)
// are denied here, because spans carry the raw URL. `forwarded` also drops
// x-forwarded-host and -proto: accepted, `host` survives.
export const noPiiDataCollection: DataCollection = {
  userInfo: false,
  cookies: false,
  httpHeaders: {
    request: { deny: PII_KEY_DENY },
    response: { deny: PII_KEY_DENY },
  },
  httpBodies: [],
  urlQueryParams: {
    deny: [...PII_KEY_DENY, ...CREDENTIAL_PARAMS, ...STRIPE_RETURN_PARAMS],
  },
  graphQL: { document: false, variables: false },
  genAI: { inputs: false, outputs: false },
  databaseQueryData: false,
  queues: false,
  stackFrameVariables: true,
  frameContextLines: 7,
};
